/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockOrderTemplates
 */
angular.module('mercury.modules.stock.stockordertemplate')
.factory('StockOrderTemplates', ["$resource", "settings", function($resource, settings) {
  var StockOrderTemplates = $resource(settings.apiHost + '/r/StockOrderTemplates/:id', {id: '@id'}, {update: {method: 'PUT'}, patch: {method: 'PATCH'}});

  /**
   * Get a summary of all active order templates
   *
   * @memberof StockOrderTemplates
   */
  function getAll() {
    return StockOrderTemplates.query({$filter: 'DatestampDeleted eq null'});
  }

  /**
   * Get the full detail of a specific order template
   *
   * @memberof StockOrderTemplates
   * @param  {String} id [description]
   */
  function get(id) {
    return StockOrderTemplates.get({id: id});
  }

  /**
   * Set an order template as deleted
   *
   * @memberof StockOrderTemplates
   * @param  {object} template template model
   */
  function remove(template) {
    return StockOrderTemplates.patch({id: template.id}, {datestampDeleted: moment().format()}).$promise;
  }

  /**
   * Create an order template
   *
   * @memberof StockOrderTemplates
   * @param  {object} template template model
   */
  function save(template) {
    return StockOrderTemplates.save(template).$promise;
  }

  /**
   * Update an existing order template
   *
   * @memberof StockOrderTemplates
   * @param  {object} template template model
   */
  function update(template) {
    return StockOrderTemplates.update(template).$promise;
  }

  return {
    getAll: getAll,
    get: get,
    remove: remove,
    save: save,
    update: update
  };
}]);
